"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var IntegrationHelper_1 = __importDefault(require("@/Helper/IntegrationHelper"));
var react_i18next_1 = require("react-i18next");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var ResourceScriptStatusPanel = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(undefined), latestJob = _a[0], setLatestJob = _a[1];
    var _b = (0, react_1.useState)(undefined), resourceList = _b[0], setResourceList = _b[1];
    var runScript = function () {
        IntegrationHelper_1.default.runScript(props.integration.id, props.identifier);
    };
    var imageResources = [];
    var dataResources = [];
    var isDynamicResource = false;
    if (props.integrationTemplate.definition.script.scripts[props.script.template]) {
        var scriptTemplate = props.integrationTemplate.definition.script.scripts[props.script.template];
        for (var key in scriptTemplate.resources) {
            if (scriptTemplate.resources[key].dynamic) {
                isDynamicResource = true;
                break;
            }
        }
    }
    var initResourcePreviews = function () { return __awaiter(void 0, void 0, void 0, function () {
        var scriptTemplate, _a, _b, _i, key, resources, resources;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!props.integrationTemplate.definition.script.scripts[props.script.template]) return [3 /*break*/, 7];
                    scriptTemplate = props.integrationTemplate.definition.script.scripts[props.script.template];
                    if (!isDynamicResource) return [3 /*break*/, 5];
                    _a = [];
                    for (_b in scriptTemplate.resources)
                        _a.push(_b);
                    _i = 0;
                    _c.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 4];
                    key = _a[_i];
                    if (!scriptTemplate.resources[key].dynamic) return [3 /*break*/, 3];
                    return [4 /*yield*/, loadScriptResourcePreviews(key)];
                case 2:
                    resources = _c.sent();
                    setResourceList(resources);
                    return [3 /*break*/, 4];
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, loadScriptResourcePreviews(props.script.template)];
                case 6:
                    resources = _c.sent();
                    setResourceList(resources);
                    _c.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var loadScriptResourcePreviews = function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var resources, scriptTemplate, data, i, params, key_1, sub, resource;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    resources = [];
                    if (!(props.jobState && props.integrationTemplate.definition.script.scripts[props.script.template])) return [3 /*break*/, 2];
                    scriptTemplate = props.integrationTemplate.definition.script.scripts[props.script.template];
                    return [4 /*yield*/, props.jobState.getDynamicResources(props.identifier, key)];
                case 1:
                    data = _b.sent();
                    for (i in data) {
                        params = ["preview=1"];
                        if ((_a = data[i].dynamic) === null || _a === void 0 ? void 0 : _a.params) {
                            for (key_1 in data[i].dynamic.params) {
                                for (sub in data[i].dynamic.params[key_1]) {
                                    params.push("dynamic[" + encodeURIComponent(key_1) + "][" + encodeURIComponent(sub) + "]=" + encodeURIComponent(data[i].dynamic.params[key_1][sub]));
                                }
                            }
                        }
                        resource = {
                            script_identifier: data[i].resource,
                            script: props.script,
                            template_identifier: key,
                            template: scriptTemplate.resources[key],
                            type: data[i].type,
                            file: data[i].type === "image"
                                ? "/api/content/integration/".concat(props.integration.id, "/").concat(props.identifier, "/image/").concat(data[i].resource, "?") + params.join("&")
                                : "/api/content/integration/".concat(props.integration.id, "/").concat(props.identifier, "/data/").concat(data[i].resource, "?") + params.join("&"),
                            generated: data[i].generated,
                        };
                        resources.push(resource);
                    }
                    _b.label = 2;
                case 2: return [2 /*return*/, resources];
            }
        });
    }); };
    if (resourceList) {
        for (var key in resourceList) {
            if (resourceList[key].type === "image") {
                imageResources.push(resourceList[key]);
            }
            else if (resourceList[key].type === "data") {
                dataResources.push(resourceList[key]);
            }
        }
    }
    var IntegrationJobStatusIcon = function (attrs) {
        if (!attrs.job.ended_at) {
            return (react_1.default.createElement("span", { style: { marginRight: "4px" } },
                react_1.default.createElement(q_play_components_1.Spinner, null)));
        }
        else {
            if (attrs.job.exit_code === 0) {
                return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-check", style: { color: "var(--info-color)", marginRight: "5px" } }));
            }
            else {
                return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-xmark", style: { color: "var(--warning-color)", margin: "0 9px 0 2px" } }));
            }
        }
    };
    var ImageWithFallback = function (_a) {
        var src = _a.src, alt = _a.alt, style = _a.style;
        var _b = (0, react_1.useState)(false), hasError = _b[0], setHasError = _b[1];
        return !hasError ? (react_1.default.createElement("img", { src: src, alt: alt, style: style, onError: function () { return setHasError(true); } })) : (react_1.default.createElement("div", { style: __assign(__assign({}, style), { display: "flex", alignItems: "center", justifyContent: "center" }) },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faImage, size: "2x", color: "#ccc" })));
    };
    var FormattedDateTime = function (attrs) {
        if (attrs.dateTime) {
            var dt = attrs.dateTime instanceof Date ? attrs.dateTime : new Date(attrs.dateTime);
            return react_1.default.createElement("span", null, dt.getDate()
                + "/" + (dt.getMonth() + 1)
                + "-" + dt.getFullYear()
                + " " + ("0" + dt.getHours()).slice(-2)
                + ":" + ("0" + dt.getMinutes()).slice(-2)
                + ":" + ("0" + dt.getSeconds()).slice(-2));
        }
        return (react_1.default.createElement("span", null, "N/A"));
    };
    var ResourcePreview = function (attr) {
        return (react_1.default.createElement("div", { style: { width: "128px", marginRight: "20px", marginBottom: "15px", position: "relative", cursor: "pointer" } },
            react_1.default.createElement("div", { onClick: function (e) {
                    e.stopPropagation();
                    props.setCurrentDataResourcePreview(attr.resource);
                }, style: {
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    background: "rgba(255,255,255,0.8)",
                    borderRadius: "50%",
                    padding: "4px",
                    zIndex: 10,
                }, title: "Show JSON preview" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFileLines, style: { color: "var(--info-color)", width: "20px", height: "20px" } })),
            attr.resource.type === "image" ? (react_1.default.createElement("a", { onClick: function () { return props.setCurrentImageResourcePreview(attr.resource); } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { style: { fontSize: ".8rem", textAlign: "center" } }, attr.resource.script_identifier ? attr.resource.script_identifier : "N/A"),
                    react_1.default.createElement("div", { style: {
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            textAlign: "center",
                            height: "128px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        } },
                        react_1.default.createElement(ImageWithFallback, { src: attr.resource.file, alt: "Resource Preview", style: { maxHeight: "100%", maxWidth: "100%", cursor: "pointer" } })),
                    react_1.default.createElement("div", { style: { fontSize: ".8rem", textAlign: "center" } },
                        react_1.default.createElement(FormattedDateTime, { dateTime: attr.resource.generated }))))) : (react_1.default.createElement("a", { onClick: function () { return props.setCurrentDataResourcePreview(attr.resource); } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { style: { fontSize: ".8rem", textAlign: "center" } }, attr.resource.script_identifier ? attr.resource.script_identifier : "N/A"),
                    react_1.default.createElement("div", { style: {
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            textAlign: "center",
                            height: "128px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        } }, "JSON"),
                    react_1.default.createElement("div", { style: { fontSize: ".8rem", textAlign: "center" } },
                        react_1.default.createElement(FormattedDateTime, { dateTime: attr.resource.generated })))))));
    };
    (0, react_1.useEffect)(function () {
        if (props.jobState) {
            var fetchJobs_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
                var jobs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, props.jobState.getScriptJobs(props.identifier)];
                        case 1:
                            jobs = _a.sent();
                            if (jobs && jobs[0]) {
                                setLatestJob(jobs[0]);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            props.jobState.onJobListChanged(function () {
                fetchJobs_1();
            });
            fetchJobs_1();
        }
    }, [props.jobState]);
    (0, react_1.useEffect)(function () {
        initResourcePreviews();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { marginBottom: "20px" } },
            react_1.default.createElement("div", { style: { border: "1px solid #ccc", borderRadius: "4px", padding: "10px 15px", marginBottom: "2px", marginTop: "10px", backgroundColor: "var(--secondary-color)" } },
                react_1.default.createElement("div", { style: { display: "flex" } },
                    react_1.default.createElement("div", null, latestJob ? react_1.default.createElement(IntegrationJobStatusIcon, { job: latestJob }) : null),
                    react_1.default.createElement("div", { style: { width: "100%" } },
                        react_1.default.createElement("strong", null, props.script.name)),
                    react_1.default.createElement("div", { style: { display: "flex", gap: "5px" } },
                        react_1.default.createElement("div", { title: "Script logs", onClick: function () { return props.onScriptSelected(props.identifier); }, style: { padding: "2px 6px 0 14px", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer" } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-file-lines", style: { marginRight: "5px" } })),
                        isDynamicResource
                            ? (react_1.default.createElement("div", { title: "Run script", style: { padding: "2px 6px 0 14px", border: "1px solid #ccc", borderRadius: "4px", opacity: ".5" } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-play", style: { marginRight: "5px" } })))
                            : (react_1.default.createElement("div", { title: "Run script", onClick: runScript, style: { padding: "2px 6px 0 14px", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer" } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-play", style: { marginRight: "5px" } })))))),
            react_1.default.createElement("div", { style: { border: "1px solid #ccc", borderRadius: "4px", padding: "10px 15px", marginBottom: "2px", marginTop: "10px" } },
                react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } }, t("Resources")),
                react_1.default.createElement("div", { style: { display: "flex", flexWrap: "wrap" } }, imageResources.map(function (resource) {
                    var key = "".concat(resource.script_identifier, "/").concat(resource.template_identifier);
                    return react_1.default.createElement(ResourcePreview, { key: key, resource: resource });
                })),
                react_1.default.createElement("div", { style: { display: "flex", flexWrap: "wrap" } }, dataResources.map(function (resource) {
                    var key = "".concat(resource.script_identifier, "/").concat(resource.template_identifier);
                    return react_1.default.createElement(ResourcePreview, { key: key, resource: resource });
                }))))));
};
exports.default = ResourceScriptStatusPanel;
